import PermissionButton from '../../permissions/PermissionButton';
import React, { useState } from 'react';
import { Form, Input, Button, Row, Col, message } from 'antd';
import { useCreateDevis } from '../../hooks/devisHooks';
import ClientList from '../client/ClientList';
import { getDefaultEntrepot } from '../../utils/defaultEntrepot';

const DevisForm = ({ onDevisCreated }) => {
  const { handleCreate } = useCreateDevis();
  const [form] = Form.useForm();
  const [selectedClient, setSelectedClient] = useState('');

  const handleFinish = async (values) => {
    try {
      const defaultEntrepot = await getDefaultEntrepot();
      const fullValues = {
        ...values,
        CODE_CLT: form.getFieldValue('CODE_CLT'),
        CLIENT: form.getFieldValue('CLIENT'),
        COMPTE: form.getFieldValue('COMPTE'),
        MODE_PAIE: form.getFieldValue('MODE_PAIE'),
        MODELIV: form.getFieldValue('MODELIV'),
        CODE_COM: form.getFieldValue('CODE_COM'),
        CODE_ENT: defaultEntrepot || null,
        MNT_HT: 0,
        MNT_TTC: 0
      };

      if (!fullValues.CLIENT) {
        message.error('Please select a client first');
        return;
      }
      
      const createdDevis = await handleCreate(fullValues);
      if (createdDevis && createdDevis.id) {
        message.success('Devis created successfully!');
        form.resetFields();
        setSelectedClient('');
        onDevisCreated(createdDevis.id);
      } else {
        message.error('Failed to create devis. Please try again.');
      }
    } catch (error) {
      console.error('Error creating devis:', error);
      message.error('An error occurred while creating the devis.');
    }
  };

  const handleClientSelect = (client) => {
    form.setFieldsValue({
      id: client.id,
      CODE_CLT:client.CODE_CLT,
      CLIENT: client.CLIENT,
      COMPTE: client.COMPTE,
      REMISE_G: client.remise_sp,
      MODE_PAIE: client.MODE_PAIE,
      MODELIV: client.MODELIV,
      CODE_COM: client.CODE_COM
    });
    
    setSelectedClient(`${client.CLIENT} (ID: ${client.id})`);
  };

  return (
    <Row gutter={[16, 16]}>
      <Col span={24}>
        <Form form={form} layout="vertical" onFinish={handleFinish}>
          <Row gutter={16} align="middle">
            <Col span={18}>
              <div className="selected-client-info" style={{
                padding: '16px',
                background: '#f0f2f5',
                borderRadius: '6px',
                height: '80px',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center'
              }}>
                <h3 style={{ margin: 0, marginBottom: selectedClient ? '8px' : 0, color: selectedClient ? '#000' : '#999' }}>
                  {selectedClient ? 'Selected Client' : 'Please select a client'}
                </h3>
                {selectedClient && <p style={{ margin: 0 }}>{selectedClient}</p>}
              </div>
            </Col>
            <Col span={6} style={{ textAlign: 'right' }}>
              <PermissionButton permissionModule="quotes" permissionAction="create"
                type="primary" 
                htmlType="submit"
                disabled={!selectedClient}
                size="large"
              >
                Create Devis
              </PermissionButton>
            </Col>
          </Row>

          <Form.Item name="id" hidden>
            <Input />
          </Form.Item>
          <Form.Item name="CLIENT" hidden>
            <Input />
          </Form.Item>
          <Form.Item name="COMPTE" hidden>
            <Input />
          </Form.Item>
          <Form.Item name="MODE_PAIE" hidden>
            <Input />
          </Form.Item>
          <Form.Item name="MODELIV" hidden>
            <Input />
          </Form.Item>
          <Form.Item name="CODE_COM" hidden>
            <Input />
          </Form.Item>
        </Form>
      </Col>
      <Col span={24}>
        <ClientList onSelectClient={handleClientSelect} showCreateButton={false} />
      </Col>
    </Row>
  );
};

export default DevisForm;
